(() => {

    document.addEventListener("DOMContentLoaded", () => {
      document.querySelectorAll('.cart-header-drawer-toggle').forEach((el) => {
        el.addEventListener('click', (event) => {
          if (window.innerWidth > 899 && !window.location.pathname.includes('/cart')) {
            event.preventDefault();
            document.getElementById('mini-cart').open = true;
          }
        });
      });
    });

    document.addEventListener("click", (evt) => {
      try {
        let parentEl = evt.target.parentElement;
        if (evt.target.classList.value.includes('addtc') || parentEl.classList.value.includes('addtc') || evt.target.classList.value.includes('add-to-cart')) {
          setTimeout(() => {
            jQuery.getJSON('/cart.js', function(cart) {
              // now have access to Shopify cart object
              const bubblesCount = document.querySelectorAll('[data-header-cart-count]');
              let showCartDrawer = false;
              let smallerBubbleCount = 0;
              bubblesCount.forEach((bubbleCount) => {
                if (smallerBubbleCount > bubbleCount.dataset.headerCartCount) {
                  smallerBubbleCount = bubbleCount.dataset.headerCartCount;
                }
                if (cart.item_count > smallerBubbleCount) {
                  bubbleCount.dataset.headerCartCount = cart.item_count;
                  showCartDrawer = true;
                }
              });
              if (showCartDrawer) {
                window.dispatchEvent(new CustomEvent("cartcount:update", {
                  bubbles: true,
                  detail: {"item_count": cart.item_count}
                }));
                if (window.innerWidth > 899 && !window.location.pathname.includes('/cart')) {
                  document.getElementById('mini-cart').open = true;
                }
              }
            });            
          }, 1000);
        }
      } catch (error) {
        console.log(error) 
      }
    })

    window.onresize = resize;
    function resize() {
      if (window.innerWidth < 899) {
        document.getElementById('mini-cart').open = false;
      }
    }
    window.themeVariables = {
        breakpoints: {
            phone: "screen and (max-width: 740px)",
            tablet: "screen and (min-width: 741px) and (max-width: 999px)",
            tabletAndUp: "screen and (min-width: 741px)",
            pocket: "screen and (max-width: 999px)",
            lap: "screen and (min-width: 1000px) and (max-width: 1199px)",
            lapAndUp: "screen and (min-width: 1000px)",
            desktop: "screen and (min-width: 1200px)",
            wide: "screen and (min-width: 1400px)"
        }
    }
    document.addEventListener("DOMContentLoaded", () => {
      document.querySelectorAll('.cart-header-drawer-toggle').forEach((el) => {
        el.addEventListener('click', (event) => {
          if (window.innerWidth > 899 && !window.location.pathname.includes('/cart')) {
            event.preventDefault();
            document.getElementById('mini-cart').open = true;
          }
        });
      });
    });

    // js/custom-element/custom-html-element.js
    var __defProp = Object.defineProperty;
    var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __publicField = (obj, key, value) => {
        __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
        return value;
    };

    function Delegate(root) {
        this.listenerMap = [{}, {}];
        if (root) {
          this.root(root);
        }
        this.handle = Delegate.prototype.handle.bind(this);
        this._removedListeners = [];
      }
      Delegate.prototype.root = function(root) {
        const listenerMap = this.listenerMap;
        let eventType;
        if (this.rootElement) {
          for (eventType in listenerMap[1]) {
            if (listenerMap[1].hasOwnProperty(eventType)) {
              this.rootElement.removeEventListener(eventType, this.handle, true);
            }
          }
          for (eventType in listenerMap[0]) {
            if (listenerMap[0].hasOwnProperty(eventType)) {
              this.rootElement.removeEventListener(eventType, this.handle, false);
            }
          }
        }
        if (!root || !root.addEventListener) {
          if (this.rootElement) {
            delete this.rootElement;
          }
          return this;
        }
        this.rootElement = root;
        for (eventType in listenerMap[1]) {
          if (listenerMap[1].hasOwnProperty(eventType)) {
            this.rootElement.addEventListener(eventType, this.handle, true);
          }
        }
        for (eventType in listenerMap[0]) {
          if (listenerMap[0].hasOwnProperty(eventType)) {
            this.rootElement.addEventListener(eventType, this.handle, false);
          }
        }
        return this;
      };
      Delegate.prototype.captureForType = function(eventType) {
        return ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(eventType) !== -1;
      };
      Delegate.prototype.on = function(eventType, selector, handler, useCapture) {
        let root;
        let listenerMap;
        let matcher;
        let matcherParam;
        if (!eventType) {
          throw new TypeError("Invalid event type: " + eventType);
        }
        if (typeof selector === "function") {
          useCapture = handler;
          handler = selector;
          selector = null;
        }
        if (useCapture === void 0) {
          useCapture = this.captureForType(eventType);
        }
        if (typeof handler !== "function") {
          throw new TypeError("Handler must be a type of Function");
        }
        root = this.rootElement;
        listenerMap = this.listenerMap[useCapture ? 1 : 0];
        if (!listenerMap[eventType]) {
          if (root) {
            root.addEventListener(eventType, this.handle, useCapture);
          }
          listenerMap[eventType] = [];
        }
        if (!selector) {
          matcherParam = null;
          matcher = matchesRoot.bind(this);
        } else if (/^[a-z]+$/i.test(selector)) {
          matcherParam = selector;
          matcher = matchesTag;
        } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
          matcherParam = selector.slice(1);
          matcher = matchesId;
        } else {
          matcherParam = selector;
          matcher = Element.prototype.matches;
        }
        listenerMap[eventType].push({
          selector,
          handler,
          matcher,
          matcherParam
        });
        return this;
      };
      Delegate.prototype.off = function(eventType, selector, handler, useCapture) {
        let i;
        let listener;
        let listenerMap;
        let listenerList;
        let singleEventType;
        if (typeof selector === "function") {
          useCapture = handler;
          handler = selector;
          selector = null;
        }
        if (useCapture === void 0) {
          this.off(eventType, selector, handler, true);
          this.off(eventType, selector, handler, false);
          return this;
        }
        listenerMap = this.listenerMap[useCapture ? 1 : 0];
        if (!eventType) {
          for (singleEventType in listenerMap) {
            if (listenerMap.hasOwnProperty(singleEventType)) {
              this.off(singleEventType, selector, handler);
            }
          }
          return this;
        }
        listenerList = listenerMap[eventType];
        if (!listenerList || !listenerList.length) {
          return this;
        }
        for (i = listenerList.length - 1; i >= 0; i--) {
          listener = listenerList[i];
          if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
            this._removedListeners.push(listener);
            listenerList.splice(i, 1);
          }
        }
        if (!listenerList.length) {
          delete listenerMap[eventType];
          if (this.rootElement) {
            this.rootElement.removeEventListener(eventType, this.handle, useCapture);
          }
        }
        return this;
      };
      Delegate.prototype.handle = function(event) {
        let i;
        let l;
        const type = event.type;
        let root;
        let phase;
        let listener;
        let returned;
        let listenerList = [];
        let target;
        const eventIgnore = "ftLabsDelegateIgnore";
        if (event[eventIgnore] === true) {
          return;
        }
        target = event.target;
        if (target.nodeType === 3) {
          target = target.parentNode;
        }
        if (target.correspondingUseElement) {
          target = target.correspondingUseElement;
        }
        root = this.rootElement;
        phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
        switch (phase) {
          case 1:
            listenerList = this.listenerMap[1][type];
            break;
          case 2:
            if (this.listenerMap[0] && this.listenerMap[0][type]) {
              listenerList = listenerList.concat(this.listenerMap[0][type]);
            }
            if (this.listenerMap[1] && this.listenerMap[1][type]) {
              listenerList = listenerList.concat(this.listenerMap[1][type]);
            }
            break;
          case 3:
            listenerList = this.listenerMap[0][type];
            break;
        }
        let toFire = [];
        l = listenerList.length;
        while (target && l) {
          for (i = 0; i < l; i++) {
            listener = listenerList[i];
            if (!listener) {
              break;
            }
            if (target.tagName && ["button", "input", "select", "textarea"].indexOf(target.tagName.toLowerCase()) > -1 && target.hasAttribute("disabled")) {
              toFire = [];
            } else if (listener.matcher.call(target, listener.matcherParam, target)) {
              toFire.push([event, target, listener]);
            }
          }
          if (target === root) {
            break;
          }
          l = listenerList.length;
          target = target.parentElement || target.parentNode;
          if (target instanceof HTMLDocument) {
            break;
          }
        }
        let ret;
        for (i = 0; i < toFire.length; i++) {
          if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
            continue;
          }
          returned = this.fire.apply(this, toFire[i]);
          if (returned === false) {
            toFire[i][0][eventIgnore] = true;
            toFire[i][0].preventDefault();
            ret = false;
            break;
          }
        }
        return ret;
      };
      Delegate.prototype.fire = function(event, target, listener) {
        return listener.handler.call(target, event, target);
      };
      function matchesTag(tagName, element) {
        return tagName.toLowerCase() === element.tagName.toLowerCase();
      }
      function matchesRoot(selector, element) {
        if (this.rootElement === window) {
          return element === document || element === document.documentElement || element === window;
        }
        return this.rootElement === element;
      }
      function matchesId(id, element) {
        return id === element.id;
      }
      Delegate.prototype.destroy = function() {
        this.off();
        this.root();
      };
      
    var main_default = Delegate;
    var CustomHTMLElement = class extends HTMLElement {
    constructor() {
      super();
      this._hasSectionReloaded = false;
      if (Shopify.designMode) {
        this.rootDelegate.on("shopify:section:select", (event) => {
          const parentSection = this.closest(".shopify-section");
          if (event.target === parentSection && event.detail.load) {
            this._hasSectionReloaded = true;
          }
        });
      }
    }
    get rootDelegate() {
      return this._rootDelegate = this._rootDelegate || new main_default(document.documentElement);
    }
    get delegate() {
      return this._delegate = this._delegate || new main_default(this);
    }
    showLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:start");
    }
    hideLoadingBar() {
      triggerEvent(document.documentElement, "theme:loading:end");
    }
    untilVisible(intersectionObserverOptions = { rootMargin: "30px 0px", threshold: 0 }) {
      const onBecameVisible = () => {
        this.classList.add("became-visible");
        this.style.opacity = "1";
      };
      return new Promise((resolve) => {
        if (window.IntersectionObserver) {
          this.intersectionObserver = new IntersectionObserver((event) => {
            if (event[0].isIntersecting) {
              this.intersectionObserver.disconnect();
              requestAnimationFrame(() => {
                resolve();
                onBecameVisible();
              });
            }
          }, intersectionObserverOptions);
          this.intersectionObserver.observe(this);
        } else {
          resolve();
          onBecameVisible();
        }
      });
    }
    disconnectedCallback() {
      var _a;
      this.delegate.destroy();
      this.rootDelegate.destroy();
      (_a = this.intersectionObserver) == null ? void 0 : _a.disconnect();
      delete this._delegate;
      delete this._rootDelegate;
    }
    };

    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
          var symbols = Object.getOwnPropertySymbols(object);
          if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
              return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
          }
          keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) {
            ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            } else {
            ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
            }
        }
        return target;
    }

    function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }
        return obj;
    }

    var activeFocusTraps = function() {
        var trapQueue = [];
        return {
          activateTrap: function activateTrap(trap) {
            if (trapQueue.length > 0) {
              var activeTrap = trapQueue[trapQueue.length - 1];
              if (activeTrap !== trap) {
                activeTrap.pause();
              }
            }
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex === -1) {
              trapQueue.push(trap);
            } else {
              trapQueue.splice(trapIndex, 1);
              trapQueue.push(trap);
            }
          },
          deactivateTrap: function deactivateTrap(trap) {
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex !== -1) {
              trapQueue.splice(trapIndex, 1);
            }
            if (trapQueue.length > 0) {
              trapQueue[trapQueue.length - 1].unpause();
            }
          }
        };
    }();

    // node_modules/tabbable/dist/index.esm.js
  var candidateSelectors = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"];
  var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
  var matches = typeof Element === "undefined" ? function() {
  } : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  var getCandidates = function getCandidates2(el, includeContainer, filter) {
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) {
      candidates.unshift(el);
    }
    candidates = candidates.filter(filter);
    return candidates;
  };
  var isContentEditable = function isContentEditable2(node) {
    return node.contentEditable === "true";
  };
  var getTabindex = function getTabindex2(node) {
    var tabindexAttr = parseInt(node.getAttribute("tabindex"), 10);
    if (!isNaN(tabindexAttr)) {
      return tabindexAttr;
    }
    if (isContentEditable(node)) {
      return 0;
    }
    if ((node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) {
      return 0;
    }
    return node.tabIndex;
  };
  var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
  };
  var isInput = function isInput2(node) {
    return node.tagName === "INPUT";
  };
  var isHiddenInput = function isHiddenInput2(node) {
    return isInput(node) && node.type === "hidden";
  };
  var isDetailsWithSummary = function isDetailsWithSummary2(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
      return child.tagName === "SUMMARY";
    });
    return r;
  };
  var getCheckedRadio = function getCheckedRadio2(nodes, form) {
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].checked && nodes[i].form === form) {
        return nodes[i];
      }
    }
  };
  var isTabbableRadio = function isTabbableRadio2(node) {
    if (!node.name) {
      return true;
    }
    var radioScope = node.form || node.ownerDocument;
    var queryRadios = function queryRadios2(name) {
      return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") {
      radioSet = queryRadios(window.CSS.escape(node.name));
    } else {
      try {
        radioSet = queryRadios(node.name);
      } catch (err) {
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
      }
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
  };
  var isRadio = function isRadio2(node) {
    return isInput(node) && node.type === "radio";
  };
  var isNonTabbableRadio = function isNonTabbableRadio2(node) {
    return isRadio(node) && !isTabbableRadio(node);
  };
  var isHidden = function isHidden2(node, displayCheck) {
    if (getComputedStyle(node).visibility === "hidden") {
      return true;
    }
    var isDirectSummary = matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, "details:not([open]) *")) {
      return true;
    }
    if (!displayCheck || displayCheck === "full") {
      while (node) {
        if (getComputedStyle(node).display === "none") {
          return true;
        }
        node = node.parentElement;
      }
    } else if (displayCheck === "non-zero-area") {
      var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
      return width === 0 && height === 0;
    }
    return false;
  };
  var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
    if (isInput(node) || node.tagName === "SELECT" || node.tagName === "TEXTAREA" || node.tagName === "BUTTON") {
      var parentNode = node.parentElement;
      while (parentNode) {
        if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
          for (var i = 0; i < parentNode.children.length; i++) {
            var child = parentNode.children.item(i);
            if (child.tagName === "LEGEND") {
              if (child.contains(node)) {
                return false;
              }
              return true;
            }
          }
          return true;
        }
        parentNode = parentNode.parentElement;
      }
    }
    return false;
  };
  var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
    if (node.disabled || isHiddenInput(node) || isHidden(node, options.displayCheck) || isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
      return false;
    }
    return true;
  };
  var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
    if (!isNodeMatchingSelectorFocusable(options, node) || isNonTabbableRadio(node) || getTabindex(node) < 0) {
      return false;
    }
    return true;
  };
  
    var tabbable = function tabbable2(el, options) {
        options = options || {};
        var regularTabbables = [];
        var orderedTabbables = [];
        var candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
        candidates.forEach(function(candidate, i) {
          var candidateTabindex = getTabindex(candidate);
          if (candidateTabindex === 0) {
            regularTabbables.push(candidate);
          } else {
            orderedTabbables.push({
              documentOrder: i,
              tabIndex: candidateTabindex,
              node: candidate
            });
          }
        });
        var tabbableNodes = orderedTabbables.sort(sortOrderedTabbables).map(function(a) {
          return a.node;
        }).concat(regularTabbables);
        return tabbableNodes;
    };

    var isSelectableInput = function isSelectableInput2(node) {
        return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
    };
    var isEscapeEvent = function isEscapeEvent2(e) {
        return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
    };
    var isTabEvent = function isTabEvent2(e) {
        return e.key === "Tab" || e.keyCode === 9;
    };
    var delay = function delay2(fn) {
        return setTimeout(fn, 0);
    };
    var findIndex = function findIndex2(arr, fn) {
        var idx = -1;
        arr.every(function(value, i) {
          if (fn(value)) {
            idx = i;
            return false;
          }
          return true;
        });
        return idx;
    };
    var valueOrHandler = function valueOrHandler2(value) {
        for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          params[_key - 1] = arguments[_key];
        }
        return typeof value === "function" ? value.apply(void 0, params) : value;
    };
    var getActualTarget = function getActualTarget2(event) {
        return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
    };
    var createFocusTrap = function createFocusTrap2(elements, userOptions) {
        var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
        var config = _objectSpread2({
          returnFocusOnDeactivate: true,
          escapeDeactivates: true,
          delayInitialFocus: true
        }, userOptions);
        var state = {
          containers: [],
          tabbableGroups: [],
          nodeFocusedBeforeActivation: null,
          mostRecentlyFocusedNode: null,
          active: false,
          paused: false,
          delayInitialFocusTimer: void 0
        };
        var trap;
        var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
          return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
        };
        var containersContain = function containersContain2(element) {
          return !!(element && state.containers.some(function(container) {
            return container.contains(element);
          }));
        };
        var getNodeForOption = function getNodeForOption2(optionName) {
          var optionValue = config[optionName];
          if (typeof optionValue === "function") {
            for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              params[_key2 - 1] = arguments[_key2];
            }
            optionValue = optionValue.apply(void 0, params);
          }
          if (!optionValue) {
            if (optionValue === void 0 || optionValue === false) {
              return optionValue;
            }
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
          }
          var node = optionValue;
          if (typeof optionValue === "string") {
            node = doc.querySelector(optionValue);
            if (!node) {
              throw new Error("`".concat(optionName, "` as selector refers to no known node"));
            }
          }
          return node;
        };
        var getInitialFocusNode = function getInitialFocusNode2() {
          var node = getNodeForOption("initialFocus");
          if (node === false) {
            return false;
          }
          if (node === void 0) {
            if (containersContain(doc.activeElement)) {
              node = doc.activeElement;
            } else {
              var firstTabbableGroup = state.tabbableGroups[0];
              var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
              node = firstTabbableNode || getNodeForOption("fallbackFocus");
            }
          }
          if (!node) {
            throw new Error("Your focus-trap needs to have at least one focusable element");
          }
          return node;
        };
        var updateTabbableNodes = function updateTabbableNodes2() {
          state.tabbableGroups = state.containers.map(function(container) {
            var tabbableNodes = tabbable(container);
            if (tabbableNodes.length > 0) {
              return {
                container,
                firstTabbableNode: tabbableNodes[0],
                lastTabbableNode: tabbableNodes[tabbableNodes.length - 1]
              };
            }
            return void 0;
          }).filter(function(group) {
            return !!group;
          });
          if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) {
            throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
          }
        };
        var tryFocus = function tryFocus2(node) {
          if (node === false) {
            return;
          }
          if (node === doc.activeElement) {
            return;
          }
          if (!node || !node.focus) {
            tryFocus2(getInitialFocusNode());
            return;
          }
          node.focus({
            preventScroll: !!config.preventScroll
          });
          state.mostRecentlyFocusedNode = node;
          if (isSelectableInput(node)) {
            node.select();
          }
        };
        var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
          var node = getNodeForOption("setReturnFocus", previousActiveElement);
          return node ? node : node === false ? false : previousActiveElement;
        };
        var checkPointerDown = function checkPointerDown2(e) {
          var target = getActualTarget(e);
          if (containersContain(target)) {
            return;
          }
          if (valueOrHandler(config.clickOutsideDeactivates, e)) {
            trap.deactivate({
              returnFocus: config.returnFocusOnDeactivate && !isFocusable(target)
            });
            return;
          }
          if (valueOrHandler(config.allowOutsideClick, e)) {
            return;
          }
          e.preventDefault();
        };
        var checkFocusIn = function checkFocusIn2(e) {
          var target = getActualTarget(e);
          var targetContained = containersContain(target);
          if (targetContained || target instanceof Document) {
            if (targetContained) {
              state.mostRecentlyFocusedNode = target;
            }
          } else {
            e.stopImmediatePropagation();
            tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
          }
        };
        var checkTab = function checkTab2(e) {
          var target = getActualTarget(e);
          updateTabbableNodes();
          var destinationNode = null;
          if (state.tabbableGroups.length > 0) {
            var containerIndex = findIndex(state.tabbableGroups, function(_ref) {
              var container = _ref.container;
              return container.contains(target);
            });
            if (containerIndex < 0) {
              if (e.shiftKey) {
                destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
              } else {
                destinationNode = state.tabbableGroups[0].firstTabbableNode;
              }
            } else if (e.shiftKey) {
              var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref2) {
                var firstTabbableNode = _ref2.firstTabbableNode;
                return target === firstTabbableNode;
              });
              if (startOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
                startOfGroupIndex = containerIndex;
              }
              if (startOfGroupIndex >= 0) {
                var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                destinationNode = destinationGroup.lastTabbableNode;
              }
            } else {
              var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
                var lastTabbableNode = _ref3.lastTabbableNode;
                return target === lastTabbableNode;
              });
              if (lastOfGroupIndex < 0 && state.tabbableGroups[containerIndex].container === target) {
                lastOfGroupIndex = containerIndex;
              }
              if (lastOfGroupIndex >= 0) {
                var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                destinationNode = _destinationGroup.firstTabbableNode;
              }
            }
          } else {
            destinationNode = getNodeForOption("fallbackFocus");
          }
          if (destinationNode) {
            e.preventDefault();
            tryFocus(destinationNode);
          }
        };
        var checkKey = function checkKey2(e) {
          if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
            e.preventDefault();
            trap.deactivate();
            return;
          }
          if (isTabEvent(e)) {
            checkTab(e);
            return;
          }
        };
        var checkClick = function checkClick2(e) {
          if (valueOrHandler(config.clickOutsideDeactivates, e)) {
            return;
          }
          var target = getActualTarget(e);
          if (containersContain(target)) {
            return;
          }
          if (valueOrHandler(config.allowOutsideClick, e)) {
            return;
          }
          e.preventDefault();
          e.stopImmediatePropagation();
        };
        var addListeners = function addListeners2() {
          if (!state.active) {
            return;
          }
          activeFocusTraps.activateTrap(trap);
          state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
            tryFocus(getInitialFocusNode());
          }) : tryFocus(getInitialFocusNode());
          doc.addEventListener("focusin", checkFocusIn, true);
          doc.addEventListener("mousedown", checkPointerDown, {
            capture: true,
            passive: false
          });
          doc.addEventListener("touchstart", checkPointerDown, {
            capture: true,
            passive: false
          });
          doc.addEventListener("click", checkClick, {
            capture: true,
            passive: false
          });
          doc.addEventListener("keydown", checkKey, {
            capture: true,
            passive: false
          });
          return trap;
        };
        var removeListeners = function removeListeners2() {
          if (!state.active) {
            return;
          }
          doc.removeEventListener("focusin", checkFocusIn, true);
          doc.removeEventListener("mousedown", checkPointerDown, true);
          doc.removeEventListener("touchstart", checkPointerDown, true);
          doc.removeEventListener("click", checkClick, true);
          doc.removeEventListener("keydown", checkKey, true);
          return trap;
        };
        trap = {
          activate: function activate(activateOptions) {
            if (state.active) {
              return this;
            }
            var onActivate = getOption(activateOptions, "onActivate");
            var onPostActivate = getOption(activateOptions, "onPostActivate");
            var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
            if (!checkCanFocusTrap) {
              updateTabbableNodes();
            }
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = doc.activeElement;
            if (onActivate) {
              onActivate();
            }
            var finishActivation = function finishActivation2() {
              if (checkCanFocusTrap) {
                updateTabbableNodes();
              }
              addListeners();
              if (onPostActivate) {
                onPostActivate();
              }
            };
            if (checkCanFocusTrap) {
              checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
              return this;
            }
            finishActivation();
            return this;
          },
          deactivate: function deactivate(deactivateOptions) {
            if (!state.active) {
              return this;
            }
            clearTimeout(state.delayInitialFocusTimer);
            state.delayInitialFocusTimer = void 0;
            removeListeners();
            state.active = false;
            state.paused = false;
            activeFocusTraps.deactivateTrap(trap);
            var onDeactivate = getOption(deactivateOptions, "onDeactivate");
            var onPostDeactivate = getOption(deactivateOptions, "onPostDeactivate");
            var checkCanReturnFocus = getOption(deactivateOptions, "checkCanReturnFocus");
            if (onDeactivate) {
              onDeactivate();
            }
            var returnFocus = getOption(deactivateOptions, "returnFocus", "returnFocusOnDeactivate");
            var finishDeactivation = function finishDeactivation2() {
              delay(function() {
                if (returnFocus) {
                  tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                }
                if (onPostDeactivate) {
                  onPostDeactivate();
                }
              });
            };
            if (returnFocus && checkCanReturnFocus) {
              checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
              return this;
            }
            finishDeactivation();
            return this;
          },
          pause: function pause() {
            if (state.paused || !state.active) {
              return this;
            }
            state.paused = true;
            removeListeners();
            return this;
          },
          unpause: function unpause() {
            if (!state.paused || !state.active) {
              return this;
            }
            state.paused = false;
            updateTabbableNodes();
            addListeners();
            return this;
          },
          updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
              return typeof element === "string" ? doc.querySelector(element) : element;
            });
            if (state.active) {
              updateTabbableNodes();
            }
            return this;
          }
        };
        trap.updateContainerElements(elements);
        return trap;
      };

    // js/helper/animation.js
    var CustomAnimation = class {
        constructor(effect) {
        this._effect = effect;
        this._playState = "idle";
        this._finished = Promise.resolve();
        }
        get finished() {
        return this._finished;
        }
        get animationEffects() {
        return this._effect instanceof CustomKeyframeEffect ? [this._effect] : this._effect.animationEffects;
        }
        cancel() {
        this.animationEffects.forEach((animationEffect) => animationEffect.cancel());
        }
        finish() {
        this.animationEffects.forEach((animationEffect) => animationEffect.finish());
        }
        play() {
        this._playState = "running";
        this._effect.play();
        this._finished = this._effect.finished;
        this._finished.then(() => {
            this._playState = "finished";
        }, (rejection) => {
            this._playState = "idle";
        });
        }
    };
    var CustomKeyframeEffect = class {
        constructor(target, keyframes, options = {}) {
          if (!target) {
            return;
          }
          if ("Animation" in window) {
            this._animation = new Animation(new KeyframeEffect(target, keyframes, options));
          } else {
            options["fill"] = "forwards";
            this._animation = target.animate(keyframes, options);
            this._animation.pause();
          }
          this._animation.addEventListener("finish", () => {
            target.style.opacity = keyframes.hasOwnProperty("opacity") ? keyframes["opacity"][keyframes["opacity"].length - 1] : null;
            target.style.visibility = keyframes.hasOwnProperty("visibility") ? keyframes["visibility"][keyframes["visibility"].length - 1] : null;
          });
        }
        get finished() {
          if (!this._animation) {
            return Promise.resolve();
          }
          return this._animation.finished ? this._animation.finished : new Promise((resolve) => this._animation.onfinish = resolve);
        }
        play() {
          if (this._animation) {
            this._animation.startTime = null;
            this._animation.play();
          }
        }
        cancel() {
          if (this._animation) {
            this._animation.cancel();
          }
        }
        finish() {
          if (this._animation) {
            this._animation.finish();
          }
        }
      };

    var GroupEffect = class {
        constructor(childrenEffects) {
          this._childrenEffects = childrenEffects;
          this._finished = Promise.resolve();
        }
        get finished() {
          return this._finished;
        }
        get animationEffects() {
          return this._childrenEffects.flatMap((effect) => {
            return effect instanceof CustomKeyframeEffect ? effect : effect.animationEffects;
          });
        }
      };
      var ParallelEffect = class extends GroupEffect {
        play() {
          const promises = [];
          for (const effect of this._childrenEffects) {
            effect.play();
            promises.push(effect.finished);
          }
          this._finished = Promise.all(promises);
        }
      };

    // js/helper/media-features.js
    var MediaFeatures = class {
        static prefersReducedMotion() {
        return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        }
        static supportsHover() {
        return window.matchMedia("(pointer: fine)").matches;
        }
    };

    // js/helper/event.js
    function triggerEvent(element, name, data = {}) {
        element.dispatchEvent(new CustomEvent(name, {
        bubbles: true,
        detail: data
        }));
    }
    function triggerNonBubblingEvent(element, name, data = {}) {
        element.dispatchEvent(new CustomEvent(name, {
        bubbles: false,
        detail: data
        }));
    }
    
    // js/custom-element/behavior/openable-element.js
    var OpenableElement = class extends CustomHTMLElement {
        static get observedAttributes() {
        return ["open"];
        }
        constructor() {
        super();
        if (Shopify.designMode) {
            this.rootDelegate.on("shopify:section:select", (event) => filterShopifyEvent(event, this, () => this.open = true));
            this.rootDelegate.on("shopify:section:deselect", (event) => filterShopifyEvent(event, this, () => this.open = false));
        }
        if (this.hasAttribute("append-body")) {
            const existingNode = document.getElementById(this.id);
            this.removeAttribute("append-body");
            if (existingNode && existingNode !== this) {
            existingNode.replaceWith(this.cloneNode(true));
            this.remove();
            } else {
            document.body.appendChild(this);
            }
        }
        }
        connectedCallback() {
        this.delegate.on("click", ".openable__overlay", () => this.open = false);
        this.delegate.on("click", '[data-action="close"]', (event) => {
            event.stopPropagation();
            this.open = false;
        });
        }
        get requiresLoading() {
        return this.hasAttribute("href");
        }
        get open() {
        return this.hasAttribute("open");
        }
        set open(value) {
        if (document.body.classList.contains('iti--opened')) return;
        
        if (value) {
            (async () => {
            await this._load();
            this.clientWidth;
            this.setAttribute("open", "");
            })();
        } else {
            this.removeAttribute("open");
        }
        }
        get shouldTrapFocus() {
        return true;
        }
        get returnFocusOnDeactivate() {
        return !this.hasAttribute("return-focus") || this.getAttribute("return-focus") === "true";
        }
        get focusTrap() {
        return this._focusTrap = this._focusTrap || createFocusTrap(this, {
            fallbackFocus: this,
            initialFocus: this.hasAttribute("initial-focus-selector") ? this.getAttribute("initial-focus-selector") : void 0,
            clickOutsideDeactivates: (event) => !(event.target.hasAttribute("aria-controls") && event.target.getAttribute("aria-controls") === this.id),
            allowOutsideClick: (event) => event.target.hasAttribute("aria-controls") && event.target.getAttribute("aria-controls") === this.id,
            returnFocusOnDeactivate: this.returnFocusOnDeactivate,
            onDeactivate: () => this.open = false,
            preventScroll: true
        });
        }
        attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case "open":
            if (oldValue === null && newValue === "") {
                if (this.shouldTrapFocus) {
                setTimeout(() => this.focusTrap.activate(), 150);
                }
                triggerEvent(this, "openable-element:open");
            } else if (newValue === null) {
                if (this.shouldTrapFocus) {
                this.focusTrap.deactivate();
                }
                triggerEvent(this, "openable-element:close");
            }
        }
        }
        async _load() {
        if (!this.requiresLoading) {
            return;
        }
        triggerNonBubblingEvent(this, "openable-element:load:start");
        const response = await fetch(this.getAttribute("href"));
        const element = document.createElement("div");
        element.innerHTML = await response.text();
        this.innerHTML = element.querySelector(this.tagName.toLowerCase()).innerHTML;
        this.removeAttribute("href");
        triggerNonBubblingEvent(this, "openable-element:load:end");
        }
    };
    window.customElements.define("openable-element", OpenableElement);

        // js/custom-element/ui/drawer.js
    var DrawerContent = class extends OpenableElement {
        connectedCallback() {
        super.connectedCallback();
        if (this.hasAttribute("reverse-breakpoint")) {
            this.originalDirection = this.classList.contains("drawer--from-left") ? "left" : "right";
            const matchMedia2 = window.matchMedia(this.getAttribute("reverse-breakpoint"));
            matchMedia2.addListener(this._checkReverseOpeningDirection.bind(this));
            this._checkReverseOpeningDirection(matchMedia2);
        }
        this.delegate.on("click", ".drawer__overlay", () => this.open = false);
        }
        attributeChangedCallback(name, oldValue, newValue) {
        super.attributeChangedCallback(name, oldValue, newValue);
        switch (name) {
            case "open":
            document.documentElement.classList.toggle("lock-all", this.open);
        }
        }
        _checkReverseOpeningDirection(match) {
        this.classList.remove("drawer--from-left");
        if (this.originalDirection === "left" && !match.matches || this.originalDirection !== "left" && match.matches) {
            this.classList.add("drawer--from-left");
        }
        }
    };
    window.customElements.define("drawer-content", DrawerContent);

    var CartPageElement = class extends CustomHTMLElement {
      connectedCallback() {
        this.delegate.on("change", "select", this._onQuantityChanged.bind(this));
        this.delegate.on("click", "a.line-item__remove-button", this._onDeleteLinkClicked.bind(this));
      }
      _onDeleteLinkClicked(event, target) {
        event.preventDefault();
        this._updateFromLink(target.href);
      }
      _onQuantityChanged(event, target) {
        event.preventDefault();
        this._updateFromLink(`/cart/change?quantity=${target.value}&line=${target.getAttribute("data-line")}`);
      }
      async _updateFromLink(link) {
        const changeUrl = new URL(link, `https://${window.location.host}`), searchParams = changeUrl.searchParams, line = searchParams.get("line"), id = searchParams.get("id"), quantity = parseInt(searchParams.get("quantity"));
        this.dispatchEvent(new CustomEvent("cart-page-element:change:start", { bubbles: true, detail: { newLineQuantity: quantity } }));
        const response = await fetch(`/cart/change.js`, {
          body: JSON.stringify({ line, id, quantity, sections: ["static-cart-drawer"] }),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          }
        });
        const cartContent = await response.json();
        this.dispatchEvent(new CustomEvent("cart-page-element:change:end", { bubbles: true, detail: { cart: cartContent, newLineQuantity: quantity } }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
          bubbles: true,
          detail: {
            cart: cartContent
          }
        }));
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: cartContent,
            replacementDelay: quantity === 0 ? 600 : 750
          }
        }));
      }
    };
    window.customElements.define("cart-page-element", CartPageElement);
    
      // js/custom-element/section/cart/cart-drawer.js
      var CartDrawer = class extends DrawerContent {
        connectedCallback() {
          super.connectedCallback();
          this.rootDelegate.on("cart:refresh", this._rerenderCart.bind(this));
          document.addEventListener("cart:refresh", this._rerenderCart.bind(this));
        }
        async _rerenderCart(event) {
          var _a;
          let cartContent = null, html = "";
          if (event.detail && event.detail["cart"] && event.detail["cart"]["sections"]) {
            cartContent = event.detail["cart"];
            html = event.detail["cart"]["sections"]["static-cart-drawer"];
          } else {
            const response = await fetch(`/?section_id=${this.getAttribute("section")}`);
            html = await response.text();
          }
          const fakeDiv = document.createElement("div");
          fakeDiv.innerHTML = html;
          setTimeout(async () => {
            var _a2;
            const previousPosition = this.querySelector(".drawer__content").scrollTop;
            if (cartContent && cartContent["item_count"] === 0) {
              const animation = new CustomAnimation(new ParallelEffect(Array.from(this.querySelectorAll(".drawer__content, .drawer__footer")).map((item) => {
                return new CustomKeyframeEffect(item, { opacity: [1, 0] }, { duration: 250, easing: "ease-in" });
              })));
              animation.play();
              await animation.finished;
            }
            if (this.querySelector('cart-page-element') != null && fakeDiv.querySelector("cart-page-element") != null) {
              this.querySelector('cart-page-element').innerHTML = fakeDiv.querySelector("cart-page-element").innerHTML;
            }
            if ( this.querySelector('#cart-drawer-reco-container') != null && fakeDiv.querySelector("#cart-drawer-reco-container") != null ) {
              this.querySelector('#cart-drawer-reco-container').innerHTML = fakeDiv.querySelector("#cart-drawer-reco-container").innerHTML;              
            }
            if ( this.querySelector('[data-cart-total]') != null && fakeDiv.querySelector('[data-cart-total]') != null ) {
              this.querySelector('[data-cart-total]').innerHTML = fakeDiv.querySelector('[data-cart-total]').innerHTML;             
            }
            if (this.querySelector('header') != null && fakeDiv.querySelector("header") != null) {
              this.querySelector('header').innerHTML = fakeDiv.querySelector('header').innerHTML;
            }
            this.innerHTML = fakeDiv.querySelector("cart-drawer").innerHTML;
            if (cartContent && cartContent["item_count"] === 0) {
              this.querySelector(".drawer__content").animate({ opacity: [0, 1], transform: ["translateY(40px)", "translateY(0)"] }, { duration: 450, easing: "cubic-bezier(0.33, 1, 0.68, 1)" });
            } else {
              this.querySelector(".drawer__content").scrollTop = previousPosition;
            }
            if ((_a2 = event == null ? void 0 : event.detail) == null ? void 0 : _a2.openMiniCart) {
              this.clientWidth;
              this.open = true;
            }
            if (cartContent) {
              window.dispatchEvent(new CustomEvent("cartcount:update", {
                bubbles: true,
                detail: {"item_count": cartContent["item_count"]}
              }));
            }
          }, ((_a = event == null ? void 0 : event.detail) == null ? void 0 : _a.replacementDelay) || 0);
        }
        async attributeChangedCallback(name, oldValue, newValue) {
          super.attributeChangedCallback(name, oldValue, newValue);
          switch (name) {
            case "open":
              if (this.open) {
                this.querySelector(".drawer__content").scrollTop = 0;
                if (!MediaFeatures.prefersReducedMotion()) {
                  const lineItems = Array.from(this.querySelectorAll(".line-item")), recommendationsInner = this.querySelector(".mini-cart__recommendations-inner"), bottomBar = this.querySelector(".drawer__footer"), effects = [];
                  if (recommendationsInner && window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
                    lineItems.push(recommendationsInner);
                  }
                  lineItems.forEach((item) => item.style.opacity = 0);
                  recommendationsInner ? recommendationsInner.style.opacity = 0 : null;
                  bottomBar ? bottomBar.style.opacity = 0 : null;
                  effects.push(new ParallelEffect(lineItems.map((item, index) => {
                    return new CustomKeyframeEffect(item, {
                      opacity: [0, 1],
                      transform: ["translateX(40px)", "translateX(0)"]
                    }, {
                      duration: 400,
                      delay: 400 + 120 * index - Math.min(2 * index * index, 120 * index),
                      easing: "cubic-bezier(0.25, 1, 0.5, 1)"
                    });
                  })));
                  if (bottomBar) {
                    effects.push(new CustomKeyframeEffect(bottomBar, {
                      opacity: [0, 1],
                      transform: ["translateY(100%)", "translateY(0)"]
                    }, {
                      duration: 300,
                      delay: 400,
                      easing: "cubic-bezier(0.25, 1, 0.5, 1)"
                    }));
                  }
                  if (recommendationsInner && !window.matchMedia(window.themeVariables.breakpoints.pocket).matches) {
                    effects.push(new CustomKeyframeEffect(recommendationsInner, {
                      opacity: [0, 1],
                      transform: ["translateX(100%)", "translateX(0)"]
                    }, {
                      duration: 250,
                      delay: 400 + Math.max(120 * lineItems.length - 25 * lineItems.length, 25),
                      easing: "cubic-bezier(0.25, 1, 0.5, 1)"
                    }));
                  }
                  let animation = new CustomAnimation(new ParallelEffect(effects));
                  animation.play();
                }
              }
          }
        }
      };
      window.customElements.define("cart-drawer", CartDrawer);
    
      // js/custom-element/section/cart/cart-drawer-recommendations.js
      var _CartDrawerRecommendations = class extends HTMLElement {
        async connectedCallback() {
          if (!_CartDrawerRecommendations.recommendationsCache[this.productId]) {
            _CartDrawerRecommendations.recommendationsCache[this.productId] = fetch(`/recommendations/products?product_id=${this.productId}&limit=10&section_id=${this.sectionId}`);
          }
          const response = await _CartDrawerRecommendations.recommendationsCache[this.productId];
          const div = document.createElement("div");
          div.innerHTML = await response.clone().text();
          const productRecommendationsElement = div.querySelector("cart-drawer-recommendations");
          if (productRecommendationsElement && productRecommendationsElement.hasChildNodes()) {
            this.innerHTML = productRecommendationsElement.innerHTML;
          } else {
            this.hidden = true;
          }
          this.add2CartButtons = this.querySelectorAll(".addToCart");
          const $elReco = this;
          this.add2CartButtons.forEach((add2CartButton) => {
            if (add2CartButton.addEventListener) {
              add2CartButton.addEventListener("click", function(evt) {
                  evt.preventDefault();
                  $elReco._onAddToCartClicked(evt, this);
                  triggerEvent(document.documentElement, "cart:refresh");
              }, true);
            } 
          })
        }
        _onAddToCartClicked(event, target) {
          let formData = {
            'items': [{
             'id': target.dataset.productVariant,
             'quantity': 1
             }]
           };
           fetch(window.Shopify.routes.root + 'cart/add.js', {
             method: 'POST',
             headers: {
               'Content-Type': 'application/json'
             },
             body: JSON.stringify(formData)
           })
           .then(response => {
            jQuery.getJSON('/cart.js', function(cart) {
              // now have access to Shopify cart object
              window.dispatchEvent(new CustomEvent("cartcount:update", {
                bubbles: true,
                detail: {"item_count": cart.item_count}
              }));
            });
             return
           })
           .catch((error) => {
             console.error('Error:', error);
           });
        }
        get productId() {
          return this.getAttribute("product-id");
        }
        get sectionId() {
          return this.getAttribute("section-id");
        }
      };
      var CartDrawerRecommendations = _CartDrawerRecommendations;
      __publicField(CartDrawerRecommendations, "recommendationsCache", {});
      window.customElements.define("cart-drawer-recommendations", CartDrawerRecommendations);

  })();